exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".leftPanel img{width:50%;max-height:95%!important;float:left;border:1px solid #bbb;margin-right:10px;-webkit-box-shadow:2px 2px 5px #aaa;box-shadow:2px 2px 5px #aaa}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e8cf9c0c","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/questions/QuestionPreview.vue
// module id = 797
// module chunks = 0